import { createSlice } from "@reduxjs/toolkit";
import { getCouponsAPI } from "../../api/coupons";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getCouponsSlice = createSlice({
  name: "getCoupons",
  initialState: data,
  reducers: {
   getCouponsSlice(state) {
      state.isLoading = true;
    },
   getCouponsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getCouponsSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getCouponsSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getCouponsHandler = (sortField:any,sortDirection:any) => async (dispatch: any) => {
  try {
    dispatch(getCouponsAction.getCouponsSlice());
    const response: any = await getCouponsAPI(sortField,sortDirection);
    
    dispatch(getCouponsAction.getCouponsSliceSuccess(response));
  } catch (e: any) {
    dispatch(getCouponsAction.getCouponsSliceFailure(e?.response?.data));
  }
};
export default getCouponsSlice.reducer;
export const getCouponsAction = getCouponsSlice.actions;
